module.exports = "/_next/static/files/c828d6a346044f6cf0aae57be2215cca.jpg";